import './style.css';
import { MultiMediaReponseType } from '../../../utils/types';
import ProductCard from './ProductCard';
import { Card } from '@chatui/core';

interface ProductType extends MultiMediaReponseType {
  currency?: string;
}

interface ProductProps {
  product: ProductType;
}

const CustProductCard = ({ product }: ProductProps) => {
  const { data } = product;
  if (!data || data.length === 0) {
    return null;
  }

  const productList = data.map((item: any, index: number) => {
    const {
      image_source,
      title,
      description,
      brand,
      product_url,
      price,
      currency,
    } = item;

    let tags = [] as any;
    if (brand) {
      if (typeof brand === 'string') {
        tags.push(brand);
      } else if (Array.isArray(brand)) {
        tags = [...brand];
      }
    }

    return (
      <ProductCard
        name={title}
        desc={description}
        img={image_source}
        price={price}
        url={product_url}
        tags={tags}
        currency={currency || product.currency || '$'}
        key={index}
      />
    );
  });
  return <Card className="card-product">{productList}</Card>;
};

export default CustProductCard;
